import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import Sidebar from '../components/Sidebar';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

function NewPurchase() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ supplier_id: '', bank_id: '' });
  const [items, setItems] = useState([{ item_id: '', quantity: 1, price: 0, total: 0 }]);
  const [allItems, setAllItems] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [banks, setBanks] = useState([]);

  useEffect(() => {
    axios.get('/items').then(res => setAllItems(res.data));
    axios.get('/suppliers').then(res => setSuppliers(res.data));
    axios.get('/banks').then(res => setBanks(res.data));
  }, []);

  const handleItemChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = field === 'quantity' || field === 'price' ? parseFloat(value) || 0 : value;
    updated[index].total = (parseFloat(updated[index].quantity) || 0) * (parseFloat(updated[index].price) || 0);
    setItems(updated);
  };

  const addRow = () => {
    setItems([...items, { item_id: '', quantity: 1, price: 0, total: 0 }]);
  };

  const removeRow = (index) => {
    const updated = items.filter((_, i) => i !== index);
    setItems(updated);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = { ...form, items };
    await axios.post('/purchases', payload);
    toast.success('Purchase created!');
    navigate('/purchases');
  };

  const grandTotal = items.reduce((sum, i) => {
    const itemTotal = parseFloat(i.total) || ((parseFloat(i.quantity) || 0) * (parseFloat(i.price) || 0));
    return sum + itemTotal;
  }, 0);

  return (
    <div className="flex">
      
      <div className=" w-full p-6">
        <h2 className="text-2xl font-bold mb-4">New Purchase</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <select value={form.supplier_id} onChange={e => setForm({ ...form, supplier_id: e.target.value })} className="border p-2 w-full">
            <option value="">Select Supplier</option>
            {suppliers.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
          </select>

          <select value={form.bank_id} onChange={e => setForm({ ...form, bank_id: e.target.value })} className="border p-2 w-full">
            <option value="">Select Bank</option>
            {banks.map(b => <option key={b.id} value={b.id}>{b.name}</option>)}
          </select>

          <table className="w-full border mt-4">
            <thead className="bg-gray-100">
              <tr>
                <th className="border p-2">Item</th>
                <th className="border p-2">Qty</th>
                <th className="border p-2">Price</th>
                <th className="border p-2">Total</th>
                <th className="border p-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, idx) => (
                <tr key={idx}>
                  <td className="border p-2">
                    <select className="w-full border p-1" value={item.item_id} onChange={e => handleItemChange(idx, 'item_id', e.target.value)}>
                      <option value="">Select</option>
                      {allItems.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                    </select>
                  </td>
                  <td className="border p-2">
                    <input type="number" value={item.quantity} onChange={e => handleItemChange(idx, 'quantity', e.target.value)} className="border p-1 w-full" />
                  </td>
                  <td className="border p-2">
                    <input type="number" value={item.price} onChange={e => handleItemChange(idx, 'price', e.target.value)} className="border p-1 w-full" />
                  </td>
                  <td className="border p-2">${(parseFloat(item.total) || 0).toFixed(2)}</td>
                  <td className="border p-2">
                    <button type="button" onClick={() => removeRow(idx)} className="text-red-600">Remove</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <button type="button" onClick={addRow} className="bg-blue-500 text-white px-4 py-2 rounded">Add Item</button>
          <p className="text-right font-bold text-lg mt-2">Grand Total: ${grandTotal.toFixed(2)}</p>
          <button type="submit" className="bg-green-600 text-white px-6 py-2 rounded">Create Purchase</button>
        </form>
      </div>
    </div>
  );
}
export default NewPurchase;